export default function parseUrlDateString(str: string) {
  if (str) {
    const data = new Date(str.replace(/(\d\d\d\d)(\d\d)(\d\d)/g, '$1-$2-$3'));
    return data;
  }
}